import {objectReducer} from '../../../shared/reducers/object-reducer';
import {RECEIVE_CHECKLIST_USER_STATUS} from './actions';

export default objectReducer({
  replaceObjectAction: RECEIVE_CHECKLIST_USER_STATUS,
});
